class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    console.log('rudmans-gift: CollectionTabs constructor called');
  }

  connectedCallback() {
    console.log('rudmans-gift: CollectionTabs connectedCallback triggered');
    // Defer initialization to ensure children are parsed
    setTimeout(() => {
      console.log('rudmans-gift: CollectionTabs child elements ready, initializing tabs');
      this.initTabs();
    }, 0);

    // Theme editor support
    this.onSectionLoadHandler = this.onSectionLoad.bind(this);
    document.addEventListener('shopify:section:load', this.onSectionLoadHandler);
  }

  disconnectedCallback() {
    console.log('rudmans-gift: CollectionTabs disconnectedCallback triggered');
    document.removeEventListener('shopify:section:load', this.onSectionLoadHandler);
  }

  onSectionLoad(event) {
    if (event.target.contains(this) || event.target === this) {
      console.log('rudmans-gift: CollectionTabs section loaded inside theme editor');
      this.initTabs();
    }
  }

  initTabs() {
    const buttons = this.querySelectorAll('.collection-tabs__tab-btn');
    const panels = this.querySelectorAll('.collection-tabs__panel');
    console.log(`rudmans-gift: Found ${buttons.length} tab buttons and ${panels.length} panels`);

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = btn.dataset.index;
        console.log(`rudmans-gift: Tab clicked: index ${index}`);
        
        // Update active tab button
        buttons.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');

        // Update active panel
        panels.forEach((panel, pIdx) => {
          if (pIdx == index) {
            panel.style.display = 'block';
            panel.classList.add('is-active');
            console.log(`rudmans-gift: Showing panel ${pIdx}`);
          } else {
            panel.style.display = 'none';
            panel.classList.remove('is-active');
          }
        });
      });
    });
  }
}

// Define the custom element
if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
  console.log('rudmans-gift: collection-tabs custom element defined');
}
